import Axios from 'axios';

class Ajax {
    constructor(el, formEl, fields, options) {
        this.el = el;
        this.formEl = formEl;
        this.loaderEl = this.el.querySelector('.reloader');
        this.messageEl = this.formEl.querySelector('.message');
        this.fields = fields;
        this.options = options;
        
        const {ajaxSubmit, url} = this.formEl.dataset;
        this.url = url;
        if (ajaxSubmit && url) {
            this.init();
        }
    }
    init() {
        this.formEl.addEventListener('submit', this.onSubmit.bind(this));
    }
    async onSubmit(event) {
        event.preventDefault();
        event.submitter.disabled = true;
        
        const formData = new FormData(this.formEl);
        this.clearMessages();
        this.clearFieldErrors();
        this.toggleLoader(true);
        
        try {
            const {data: {messages, pdf_url, send}} = await Axios.post(this.url, formData);
            
            if (send) {
                this.formSent = true;
                this.showSuccessMessages(messages);
                this.dispatchFormSentEvent(pdf_url);
                this.formEl.reset();
            } else {
                this.displayFieldErrors(messages);
                this.refreshRecaptcha();
            }
        } catch (e) {
            console.error(e);
        } finally {
            this.toggleLoader(false);
            event.submitter.disabled = false;
        }
    }
    toggleLoader(show = true) {
        if (show) {
            this.loaderEl.classList.remove('hide');
        } else {
            this.loaderEl.classList.add('hide');
        }
    }
    clearMessages() {
        this.messageEl.innerHTML = '';
        return this.messageEl;
    }
    clearFieldErrors() {
        this.formEl.querySelectorAll('.error').forEach(el => el.remove());
    }
    showSuccessMessages(messages) {
        if (!Array.isArray(messages)) return;

        const reveal = document.querySelector('[data-open="modal-form-sent"]');
        const modalClass = reveal.getAttribute('data-class');
        const modalTitle = reveal.getAttribute('data-title');

        const modalContent = document.createElement('div');
        modalContent.className = 'alert-box';
        
        messages.forEach((message, index) => {
            modalContent.appendChild(document.createTextNode(message));
            if (index < messages.length - 1) {
                modalContent.appendChild(document.createElement('br'));
            }
        });

        setTimeout(() => {
            modal(modalTitle, modalContent, '', modalClass);
        }, 0);

        this.el.scrollIntoView();
    }
    displayFieldErrors(messages) {
        Object.entries(messages).forEach(([fieldKey, errors]) => {
            const fieldElement = this.findFieldElement(fieldKey);
            const fieldContainer = fieldElement?.closest('.field');
            
            if (fieldContainer && Array.isArray(errors)) {
                errors.forEach(error => {
                    const errorEl = document.createElement('p');
                    errorEl.className = 'error';
                    errorEl.textContent = fieldKey.includes('regulations') 
                        ? __('Musisz zaznaczyć zgodę') 
                        : error;
                    fieldContainer.appendChild(errorEl);
                });
            }
        });
    }
    findFieldElement(fieldKey) {
        const selector = fieldKey.includes('.') 
            ? `[name="${fieldKey.replace('.', '[')}]"]`
            : `[name="${fieldKey}"]`;
        return this.formEl.querySelector(selector);
    }
    dispatchFormSentEvent(pdfUrl) {
        const event = new CustomEvent('form-sent', {
            bubbles: true,
            detail: { 
                form: this.formEl,
                pdfUrl: pdfUrl
            }
        });
        this.formEl.dispatchEvent(event);
    }
    refreshRecaptcha() {
        const recaptchaField = this.formEl.querySelector('[name="g-recaptcha-response"]');
        
        if (!recaptchaField || !recaptchaField.id) return;

        const id = recaptchaField.id.split("g-recaptcha-response-")[1];

        if (!id) return;

        const refreshFunctionName = 'refreshRecaptcha' + id;
        if (typeof window[refreshFunctionName] !== "function") return;

        window[refreshFunctionName]();  
    }
}

export default Ajax;